module.exports = __webpack_public_path__ + "static/media/latrobe.15233011.png";